<div class="container pb-4 pt-4">
  <app-breadcrumb [currentRouteName]="'Notes de version ' + activeProduct?.name"></app-breadcrumb>
  <h1 class="pt-3 pb-2">Notes de version de {{activeProduct?.name}}</h1>

  @if(!activeMinorVersion) {
    <ls-spinner></ls-spinner>
  } @else {
    <div class="row">
      <div class="col-md-2">
        <ul class="list-unstyled">
          @for(key of sortedByMinorVersions.keys(); track key) {
            <li class="pt-2 pb-2 text-decoration-underline text-primary" [class.text-decoration-underline]="activeMinorVersion == key">
              <a type="button" (click)="updateRoute(key)">Version {{key}}</a>
            </li>
          }
        </ul>
      </div>
      <div class="col-md-10" >
        <h3>Notes de version {{activeMinorVersion}}</h3>
        <app-search-bar (search)="search = $event" [searchVal]="search" ></app-search-bar>
        @if(search) {
          <span class="text-info">
            {{(sortedByMinorVersions.get(activeMinorVersion) | search:search).length}} note(s) de version trouvée(s) contenant le(s) mot(s) clé(s) "{{search}}"
          </span>
        }

        <div [markjsHighlight]="search">
          @for(v of sortedByMinorVersions.get(activeMinorVersion) | search:search; track v) {
            <div class="block-shadow p-3 bg-white position-relative" >
              <h3>Note de version {{v.name}}</h3>
              <p class="fst-italic text-light-grey">Publiée le {{ v.released_at | date:'d MMMM y'}}</p>
              <div [innerHTML]="v.description_html"></div>
            </div>
          } @empty {
            <p class="text-light-grey">Aucun résultat</p>
          }
        </div>
      </div>
    </div>
  }
</div>

<ls-back-to-top class="d-md-none d-block"></ls-back-to-top>

